import React, {Component} from 'react'

class SelectFreeWord extends Component {
  handleChange = (e) => {
    this.props.actions.changeSelectFreeWord({
      selectFreeWord: e.target.value,
    })
  }

  render() {
    return (
      <div className='searchArea__item'>
        <h3 className='searchArea__title'>{TRUCKERS.LANG.ITEM.LIST_SEARCH.FREE_WORD.TITLE}</h3>
        <p>
          <input
            className='input size-s'
            placeholder={TRUCKERS.LANG.ITEM.LIST_SEARCH.FREE_WORD.PLACEHOLDER}
            value={this.props.selectFreeWord}
            onChange={this.handleChange}
          />
          {TRUCKERS.LANG.ITEM.LIST_SEARCH.FREE_WORD.INCLUDING}
        </p>
      </div>
    )
  }
}
export default SelectFreeWord
